import { sendAmplitudeEvent } from '@html/_common/utils';

export default function AOCommunityBanner() {
  const initiate = () => {
    $(document).on('click', '.js-ao-community-banner-info__cta-button', (event) => {
      const $banner = $(event.currentTarget).closest('.js-ao-community-banner');
      const bannerSource = $banner.attr('data-source') || 'Unknown';

      sendAmplitudeEvent({
        ampEventName: 'community_forum_banner_clicked',
        banner_source: bannerSource,
      });
    });
  };

  return { initiate };
}
